import Text from "theme/Text";
import React from 'react'

export const StatisticItem = ( { children } ) => {
	return (
		<Text
			category={"s2"}>

			{ children }
		</Text>
	);
}
